/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_check_box } from './toggle/check_box.icon';
import { icon_indeterminate_check_box } from './toggle/indeterminate_check_box.icon';
import { icon_check_box_outline_blank } from './toggle/check_box_outline_blank.icon';
import { icon_radio_button_unchecked } from './toggle/radio_button_unchecked.icon';
import { icon_star } from './toggle/star.icon';
import { icon_radio_button_checked } from './toggle/radio_button_checked.icon';
import { icon_star_border } from './toggle/star_border.icon';
import { icon_star_half } from './toggle/star_half.icon';
var icons = {
  "check_box" : icon_check_box,
"indeterminate_check_box" : icon_indeterminate_check_box,
"check_box_outline_blank" : icon_check_box_outline_blank,
"radio_button_unchecked" : icon_radio_button_unchecked,
"star" : icon_star,
"radio_button_checked" : icon_radio_button_checked,
"star_border" : icon_star_border,
"star_half" : icon_star_half,
};
export { icons };
